var _FileSkeletonDescriptor_domElem;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import React from 'react';
import { Skeleton } from '@gravity-ui/uikit';
import { cn } from '../../../../classname';
import { ReactWidgetDescriptor } from '../../WidgetDecoration';
import './skeleton.css';
const b = cn('file-skeleton');
export class FileSkeletonDescriptor extends ReactWidgetDescriptor {
    constructor(initPos) {
        super(initPos, 'yfm_file_skeleton');
        _FileSkeletonDescriptor_domElem.set(this, void 0);
        __classPrivateFieldSet(this, _FileSkeletonDescriptor_domElem, document.createElement('span'), "f");
        __classPrivateFieldGet(this, _FileSkeletonDescriptor_domElem, "f").classList.add(b(), 'yfm-file');
    }
    getDomElem() {
        return __classPrivateFieldGet(this, _FileSkeletonDescriptor_domElem, "f");
    }
    renderReactElement() {
        return (React.createElement(React.Fragment, null,
            React.createElement("span", { className: "yfm-file__icon" }),
            React.createElement(Skeleton, { className: b('skeleton') })));
    }
}
_FileSkeletonDescriptor_domElem = new WeakMap();
